module.exports = __webpack_public_path__ + "static/media/add-season-02.deec1ca9.png";